// tslint:disable:max-line-length

import React from 'react';

export const ActionShare = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M13,10c-0.9,0-1.7,0.4-2.3,1.1L5.9,8.8C5.9,8.6,6,8.3,6,8c0-0.1,0-0.3,0-0.4L10.8,5c0.5,0.6,1.3,1,2.2,1c1.7,0,3-1.3,3-3 s-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.5,0.1,0.7L5.4,6.2C4.8,5.5,4,5,3,5C1.3,5,0,6.3,0,8s1.3,3,3,3c0.8,0,1.6-0.3,2.1-0.9l4.9,2.3 c0,0.2-0.1,0.4-0.1,0.6c0,1.7,1.3,3,3,3s3-1.3,3-3S14.7,10,13,10z" />
    </svg>
  );
};
